"use strict";

var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/string/#/contains/shim.js
// module id = ../../../../es5-ext/string/#/contains/shim.js
// module chunks = 4